import RcBtn from '@/libvue/components/button/Button.vue';

// Cross version component registration
// vuejs2: Vue.component("foo", bar)
// vuejs3: app.component("foo", bar)
export const registerComponent = (app) => {
  app.component('RcBtn', RcBtn);
};
